import React from 'react';
import Modal from './Modal';
import ActionButtons from './ActionButtons';
import { useI18n } from '../../context/I18nContext';

type ModalSize = 'sm' | 'md' | 'lg' | 'xl' | 'full';

interface BaseFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  resourceKey?: 'leads' | 'projects' | 'messages' | 'finances' | 'organization' | 'payments';
  size?: ModalSize;
  isLoading?: boolean;
  mode?: 'create' | 'update';
  onValidate?: () => void;
  showAbandon?: boolean;
  onAbandon?: () => void;
  abandonText?: string;
  validateText?: string;
  children: React.ReactNode;
}

const BaseFormModal: React.FC<BaseFormModalProps> = ({
  isOpen,
  onClose,
  title,
  resourceKey,
  size = 'md',
  isLoading = false,
  mode = 'create',
  onValidate,
  showAbandon = false,
  onAbandon,
  abandonText,
  validateText,
  children,
}) => {
  const { t } = useI18n();
  // Default validate text (computed but handled inside ActionButtons now)
  // In update mode, just show the singular resource name (e.g. "Projet" instead of "Mettre à jour Projet")
  const computedTitle = title || (resourceKey ? `${mode === 'create' ? t('common.new') + ' ' : ''}${t(resourceKey + '.singular')}` : undefined);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={computedTitle}
      size={size}
      footer={
        <ActionButtons
          onCancel={onClose}
          onValidate={onValidate || onClose}
          showAbandon={showAbandon}
          onAbandon={onAbandon}
          abandonText={abandonText}
          validateText={validateText}
          loading={isLoading}
        />
      }
    >
      <div className="space-y-6">{children}</div>
    </Modal>
  );
};

export default BaseFormModal;
